export const IMPERATIVE_NAVIGATE_ID = 'imperative-navigate';
